
import Component from "vue-class-component";
import Vue from "vue";
import {Prop} from "vue-property-decorator";
import {
    ApplicationActions,
    ApplicationViewModel,
    RequirementFulfillmentViewModel,
    RequirementsClient, DuplicationReasonModel, DuplicationReasonRequirementViewModel, factory, ResultError
} from "@/api-client";
import LabelOptional from "@/features/shared/components/LabelOptional.vue";
import {ls} from "@/CultureService";
import toasts from "@/components/Toasts";

class ReasonOption {
    constructor(public value: string, public text: string) {
    }
}

@Component({
    components: {
        LabelOptional
    }
})
export default class DuplicationReasonRequirement extends Vue {
    public static requirementDescriptionTitle = ls.Applications_Requirements_DuplicationReason_Title_DuplicationReason;
    public static headingDescription = ls.Applications_Requirements_DuplicationReason_Heading_ApplyingForDuplicate;

    @Prop({required: true})
    application!: ApplicationViewModel; // TODO: Constrain this.
    @Prop({required: true})
    requirementFulfillment!: RequirementFulfillmentViewModel;
    @Prop({required: true})
    requirement!: DuplicationReasonRequirementViewModel;
    @Prop({required: true})
    requirementValue!: DuplicationReasonModel | null;
    @Prop({required: true})
    actions!: ApplicationActions;

    selectedReasonTypeKey = "";
    additionalInfo = "";
    reasonOptions: ReasonOption[] = [];
    validationError: ResultError = factory.create(ResultError);

    async created() {
        if (this.requirementValue) {
            await new RequirementsClient()
                .chosenDuplicationReason(this.application.id, this.requirement.id)
                .then(result => {
                    this.selectedReasonTypeKey = result.reasonType.key
                    this.additionalInfo = result.additionalInfo || ""
                });
        }

        await new RequirementsClient()
            .duplicationReasonTypes(this.application.id, this.requirement.id)
            .then(result => this.reasonOptions = result.map(x => new ReasonOption(x.key, x.name)));
    }

    async submit() {
        await new RequirementsClient()
            .chooseDuplicationReason(this.selectedReasonTypeKey, this.additionalInfo, this.application.id, this.requirement.id).then(
                () => {
                    toasts.success(this.$ls.Global_Toast_SaveSuccess);
                    this.$emit("application-changed");
                },
                error => this.setValidationErrors(error, this.$ls.Global_Toast_FormSaveFailure));
    }
}
